import { message as messageAntd } from 'antd'
import _fetch from 'isomorphic-fetch'
import { app } from 'xadmin'

const fetch = (url, options = {}) => {
  let status, statusText, headers = {}, body, json
  const isGETMethod = options?.method == undefined || options?.method == 'GET'

  return _fetch(url, options)
    .then(response => {
      for (let pair of response.headers.entries()) {
        headers[pair[0]] = pair[1]
      }
      status = response.status
      statusText = response.statusText
      return response
    })
    .then(response => response.text())
    .then(text => {
      body = text
      try {
        json = JSON.parse(text)
      } catch (e) {
        // not json, no big deal
      }
      let userName, userJson
      // 修复重定向多次登陆问题
      const _location = window.location
      const locaPathname = _location.pathname
      let router = _location?.hash?.substring(1)

      if (router.indexOf('/login?redirect') != -1) {
        const index = router.lastIndexOf('/login?redirect')
        router = router.substring(index)
      } else {
        // router还是如果login的话就返回空
        const _router = (_.includes(router, '/login') ? '' : router)
        const encod_router = encodeURIComponent(_router)
        router = '/login?redirect=' + encod_router
      }

      const store = app.context.store
      if (store && store.getState()) {
        let { user } = store.getState()
        userName = user?.username
      }
      if (userName) {
        userJson = sessionStorage.getItem(`user/${userName}${locaPathname}`) || localStorage.getItem(`user/${userName}${locaPathname}`)
      } else {
        userJson = sessionStorage.getItem(`user${locaPathname}`) || localStorage.getItem(`user${locaPathname}`)
      }

      if (status == 401) {
        if (json?.message == '用户长时间未修改密码,请修改密码') {
          if (userJson) {
            let userId = JSON.parse(userJson)?.userId
            app.go(`/pwdPage?id=${userId}`)
            return Promise.reject({ message: json.message })
          }
        } else if (json?.message == '用户长时间未进行操作,请重新登录') {
          app.go(`${router}`)
          messageAntd.destroy()
          messageAntd.error(json.message)
          return Promise.reject({ message: json.message })
        } else {
          // 未登录
          store.dispatch({ type: '@@xadmin/AUTH_SIGN_OUT_FINISH' })
          store.dispatch({ type: '@@login/GET_ERROR_MESSAGE' })
          app.go(`${router}`)

          return Promise.reject({ message: "未登录" })
        }
      } else if (status == 403) {
        if (json.message == '无权限访问中台') {
          app.go('login')
          return Promise.reject({ message: json.message })
        } else {
          // 取消GET方法 无权限提醒
          if (!isGETMethod) {
            messageAntd.error({ key: '您没有权限进行该操作', content: '您没有权限进行该操作' })
          }
        }
      }

      if (status < 200 || status >= 300) {
        let message = body || statusText
        if (json && json.error && json.error.message) {
          message = json.error.message
          messageAntd.error({ key: message, content: message })
        }

        if (json?.message) {
          // 取消GET方法 403无权限提醒
          if (!isGETMethod || status != 403) {
            message = json?.message
            messageAntd.error({ key: message, content: message })
          }
        }

        if (json && json.disabled) {
          // 用户禁用
          message = json.disabled
          messageAntd.error({ key: message, content: message })
        }

        if (status >= 500) {
          // 服务器错误，弹出错误提示
          message = '服务器出现了错误，请联系系统管理员。'
          messageAntd.error({ key: message, content: message })

        }
        if (status == 406) {
          app.go('/nolicense')
        }
        if (status == 417) {
          app.go('/nopermission')
          return Promise.reject({ message: json.message })
        }

        if (json && json.license) {
          // 授权错误，统一报错
          message = '请您更新授权:' + json.license
          messageAntd.error({ key: message, content: message })
        }

        return Promise.reject({ message, status, headers, json })
      }
      return { status, headers, body, json }
    })
}

export default fetch
